import { render, staticRenderFns } from "./m_GaugeCard.vue?vue&type=template&id=0c3818b0&scoped=true&"
import script from "./m_GaugeCard.vue?vue&type=script&lang=js&"
export * from "./m_GaugeCard.vue?vue&type=script&lang=js&"
import style0 from "./m_GaugeCard.vue?vue&type=style&index=0&id=0c3818b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3818b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
